import { Action } from '@ngrx/store';
import { WireNode, Wire } from '../../types/wire.types';

export const LOAD_WIRES_LIST = '[Wires] Load Wires List';

export const LOAD_WIRES_LIST_SUCCESS = '[Wires] Load Wires List Success';

export const LOAD_WIRES_LIST_ERROR = '[Wires] Load Wires List Error';

export const LOAD_WIRE_CONTENT = '[Wires] Load Wire content';

export const LOAD_WIRE_CONTENT_SUCCESS = '[Wires] Load Wire content success';

export const LOAD_WIRE_CONTENT_ERROR = '[Wires] Load Wire content error';

export const EMPTY_WIRE_CONTENT = '[Wires] Empty Wire content';

export const INITIATE_PRINT_ALL_WIRES = '[Wires] Initiate Print all wires';
export const PRINT_ALL_WIRES = '[Wires] Print all wires';

export class LoadWiresList implements Action {
  public readonly type = LOAD_WIRES_LIST;

  constructor(public payload: string) { }
}

export class LoadWiresListSuccess implements Action {
  public readonly type = LOAD_WIRES_LIST_SUCCESS;

  constructor(public payload: WireNode[]) { }
}

export class LoadWiresListError implements Action {
  public readonly type = LOAD_WIRES_LIST_ERROR;

  constructor(public payload: any) { }
}

export class EmptyWireContent implements Action {
  public readonly type = EMPTY_WIRE_CONTENT;
}

export class LoadWireContent implements Action {
  public readonly type = LOAD_WIRE_CONTENT;

  constructor(public payload: number) { }
}

export class LoadWireContentSuccess implements Action {
  public readonly type = LOAD_WIRE_CONTENT_SUCCESS;

  constructor(public payload: Wire) { }
}

export class LoadWireContentError implements Action {
  public readonly type = LOAD_WIRE_CONTENT_ERROR;

  constructor(public payload: string) { }
}

export class InitiatePrintAllWires implements Action {
  public readonly type = INITIATE_PRINT_ALL_WIRES;
}

export class PrintAllWires implements Action {
  public readonly type = PRINT_ALL_WIRES;

  constructor(public wires) { }
}

export type WiresActions =
  | LoadWiresList
  | LoadWiresListSuccess
  | LoadWiresListError
  | EmptyWireContent
  | LoadWireContent
  | LoadWireContentSuccess
  | LoadWireContentError
  | InitiatePrintAllWires
  | PrintAllWires;
